module.exports = __webpack_public_path__ + "static/media/empty.2ea7354a.svg";